import { useContext } from 'react'
import { PrisonContext } from '../providers/prisonProvider/PrisonProvider'

export default function usePrisonAccess() {
  return useContext(PrisonContext)
}
